const physicalToStructural = {
  CHEST: 'TORSO',
  RIGHT_ARM_UPPER: 'RIGHT_ARM',
  RIGHT_ARM_LOWER: 'RIGHT_ARM',
  RIGHT_HAND: 'RIGHT_ARM',
  LEFT_ARM_UPPER: 'LEFT_ARM',
  LEFT_ARM_LOWER: 'LEFT_ARM',
  LEFT_HAND: 'LEFT_ARM',
  ABDOMEN: 'TORSO',
  BACK_UPPER: 'TORSO',
  BACK_LOWER: 'TORSO',
  BUTTOCKS: 'TORSO',
  GENITALIA: 'TORSO',
  RIGHT_LEG_UPPER: 'RIGHT_LEG',
  RIGHT_LEG_LOWER: 'RIGHT_LEG',
  RIGHT_FOOT: 'RIGHT_LEG',
  LEFT_LEG_UPPER: 'LEFT_LEG',
  LEFT_LEG_LOWER: 'LEFT_LEG',
  LEFT_FOOT: 'LEFT_LEG',
  NOSE: 'HEAD',
  EARS: 'HEAD',
};

module.exports = physicalToStructural;
